export default function importFacebookSdk() {
    window.fbAsyncInit = () => {
        window.FB.init({
            appId: process.env.VUE_APP_FACEBOOK_AUTH_CLIENT_ID,
            autoLogAppEvents: true,
            xfbml: true,
            version: 'v12.0',
        })
    }

    const fbScript = document.createElement('script')
    fbScript.src = 'https://connect.facebook.net/en_US/sdk.js'
    fbScript.defer = true
    fbScript.async = true
    document.head.appendChild(fbScript)
}
